import type { IPropList } from '@/components/materialTable/src/config/tableConfig'
import { getLangeKey } from '@/data/i18n/translateLang'

type HeaderT = ({
  temp: string
  require?: boolean
} & IPropList)[]
const headerList: HeaderT = [
  {
    prop: 'select',
    selectProp: 'isSelected',
    headSlotName: 'headSelect',
    label: getLangeKey('选择'),
    widthType: 'width',
    width: '64px',
    minWidth: '64px',
    maxWidth: '150px',
    temp: '选择',
    customLabel: getLangeKey('选择'),
  },
  {
    prop: 'plankID',
    headSlotName: 'headPlankID',
    label: getLangeKey('板号'),
    widthType: 'width',
    width: '86px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '1',
    customLabel: getLangeKey('板号'),
  },
  {
    prop: 'roomName',
    headSlotName: 'headRoomName',
    label: getLangeKey('房间'),
    interactionType: 'input',
    widthType: 'width',
    width: '80px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '主卧',
    customLabel: getLangeKey('房间'),
  },
  {
    prop: 'loc',
    headSlotName: 'headLoc',
    label: getLangeKey('柜体'),
    interactionType: 'input',
    widthType: 'width',
    width: '63px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '柜A',
    customLabel: getLangeKey('柜体'),
  },

  {
    prop: 'partName',
    headSlotName: 'headPartName',
    label: getLangeKey('板件名称'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '主卧_柜A_中立板01',
    customLabel: getLangeKey('板件名称'),
  },
  {
    prop: 'matCode',
    headSlotName: 'headMatCode',
    label: getLangeKey('材质'),
    interactionType: 'input',
    widthType: 'width',
    width: '110px',
    minWidth: '60px',
    maxWidth: '150px',
    tooltip: true,
    verify: true,
    temp: '多层实木',
    require: true,
    customLabel: getLangeKey('材质'),
  },
  {
    prop: 'is_high_gloss_plank',
    headSlotName: 'headHighPlank',
    label: getLangeKey('高光板'),
    interactionType: 'select',
    widthType: 'width',
    width: '110px',
    minWidth: '60px',
    maxWidth: '150px',
    tooltip: true,
    verify: true,
    temp: '单饰面板',
    customLabel: getLangeKey('高光板'),
  },
  {
    prop: 'texture',
    headSlotName: 'headTexture',
    label: getLangeKey('颜色'),
    interactionType: 'input',
    widthType: 'width',
    width: '100px',
    minWidth: '60px',
    maxWidth: '150px',
    tooltip: true,
    verify: true,
    temp: 'T01',
    require: true,
    customLabel: getLangeKey('颜色'),
  },
  {
    prop: 'thick',
    headSlotName: 'headThick',
    label: getLangeKey('厚度'),
    interactionType: 'input',
    widthType: 'width',
    width: '78px',
    minWidth: '60px',
    maxWidth: '150px',
    verify: true,
    temp: '18',
    require: true,
    customLabel: getLangeKey('厚度'),
  },
  {
    prop: 'specHeight',
    headSlotName: 'headSpecHeight',
    label: getLangeKey('成品长度'),
    interactionType: 'input',
    widthType: 'width',
    width: '150px',
    minWidth: '100px',
    maxWidth: '150px',
    verify: true,
    temp: '2440',
    require: true,
    customLabel: getLangeKey('成品长度'),
  },
  {
    prop: 'specWidth',
    headSlotName: 'headSpecWidth',
    label: getLangeKey('成品宽度'),
    interactionType: 'input',
    widthType: 'width',
    width: '150px',
    minWidth: '100px',
    maxWidth: '150px',
    verify: true,
    temp: '1220',
    require: true,
    customLabel: getLangeKey('成品宽度'),
  },
  {
    prop: 'amount',
    headSlotName: 'headAmount',
    label: getLangeKey('数量'),
    interactionType: 'input',
    widthType: 'width',
    width: '78px',
    minWidth: '60px',
    maxWidth: '150px',
    verify: true,
    temp: '1',
    require: true,
    customLabel: getLangeKey('数量'),
  },
  {
    prop: 'texDir',
    headSlotName: 'headTexDir',
    label: getLangeKey('纹理'),
    widthType: 'width',
    width: '126px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '竖纹',
    require: true,
    customLabel: getLangeKey('纹理'),
  },
  {
    prop: 'hsInfo',
    headSlotName: 'headHsInfo',
    label: getLangeKey('孔槽数量'),
    widthType: 'width',
    width: '126px',
    minWidth: '100px',
    maxWidth: '150px',
    temp: '1孔1槽',
    customLabel: getLangeKey('孔槽数量'),
  },
  {
    prop: 'frontEdge',
    headSlotName: 'headFrontEdge',
    label: getLangeKey('前封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '70px',
    maxWidth: '150px',
    temp: '0',
    customLabel: getLangeKey('前封边'),
  },
  {
    prop: 'backEdge',
    headSlotName: 'headBackEdge',
    label: getLangeKey('后封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '70px',
    maxWidth: '150px',
    temp: '0',
    customLabel: getLangeKey('后封边'),
  },
  {
    prop: 'leftEdge',
    headSlotName: 'headLeftEdge',
    label: getLangeKey('左封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '70px',
    maxWidth: '150px',
    temp: '0',
    customLabel: getLangeKey('左封边'),
  },
  {
    prop: 'rightEdge',
    headSlotName: 'headRightEdge',
    label: getLangeKey('右封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '70px',
    maxWidth: '150px',
    temp: '0',
    customLabel: getLangeKey('右封边'),
  },
  {
    prop: 'specialShape',
    headSlotName: 'headSpecialShape',
    label: getLangeKey('异形'),
    widthType: 'width',
    width: '63px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '异形',
    customLabel: getLangeKey('异形'),
  },
  {
    prop: 'type',
    headSlotName: 'headType',
    label: getLangeKey('门板'),
    widthType: 'width',
    width: '63px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '门板',
    customLabel: getLangeKey('门板'),
  },
  {
    prop: 'plankNum',
    headSlotName: 'headPlankNum',
    label: getLangeKey('板件条码'),
    // interactionType: 'input',
    widthType: 'width',
    width: '120px',
    minWidth: '100px',
    maxWidth: '150px',
    temp: '6100200300400',
    customLabel: getLangeKey('板件条码'),
  },
  {
    prop: 'address',
    headSlotName: 'headAddress',
    label: getLangeKey('项目地址'),
    interactionType: 'input',
    widthType: 'width',
    width: '120px',
    minWidth: '100px',
    maxWidth: '150px',
    temp: '订单一',
    customLabel: getLangeKey('项目地址'),
  },
  {
    prop: 'orderNo',
    headSlotName: 'headOrderNo',
    label: getLangeKey('订单号'),
    interactionType: 'input',
    widthType: 'width',
    width: '80px',
    minWidth: '70px',
    maxWidth: '150px',
    temp: '211006-35',
    customLabel: getLangeKey('订单号'),
  },
  {
    prop: 'customer_name',
    headSlotName: 'headCustomerName',
    interactionType: 'input',
    label: getLangeKey('客户'),
    widthType: 'width',
    width: '63px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '张总',
    customLabel: getLangeKey('客户'),
  },
  {
    prop: 'plank_remarks',
    headSlotName: 'headPlankRemarks',
    interactionType: 'input',
    label: getLangeKey('板件备注'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '板件备注',
    customLabel: getLangeKey('板件备注'),
  },
  {
    prop: 'remark',
    headSlotName: 'headRemark',
    interactionType: 'input',
    label: getLangeKey('房间备注'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '房间备注',
    customLabel: getLangeKey('房间备注'),
  },

  {
    prop: 'openDir',
    headSlotName: 'headOpenDir',
    interactionType: 'input',
    label: getLangeKey('开门方向'),
    widthType: 'width',
    width: '110px',
    minWidth: '60px',
    maxWidth: '200px',
    tooltip: true,
    temp: '左开',
    customLabel: getLangeKey('开门方向'),
  },
  {
    prop: 'hingeInfo',
    headSlotName: 'headHingeInfo',
    label: getLangeKey('铰链数据'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '距上100',
    customLabel: getLangeKey('铰链数据'),
  },
  {
    prop: 'order_remark',
    headSlotName: 'headOrderRemark',
    interactionType: 'input',
    label: getLangeKey('订单备注'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '订单备注',
    customLabel: getLangeKey('订单备注'),
  },
  {
    prop: 'process_label',
    headSlotName: 'headProcessLabel',
    // interactionType: 'input',
    label: getLangeKey('特殊工艺'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '特殊工艺',
    customLabel: getLangeKey('特殊工艺'),
  },
  {
    prop: 'partNameWithoutRoomCabinet',
    headSlotName: 'headPartNameWithoutRoomCabinet',
    label: getLangeKey('板件名称(不含房间柜体)'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '中立板01',
    customLabel: getLangeKey('板件名称(不含房间柜体)'),
  },
  {
    prop: 'finishedArea',
    headSlotName: 'headFinishedArea',
    label: getLangeKey('成品面积(㎡)'),
    widthType: 'width',
    width: '106px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '2.98',
    customLabel: getLangeKey('成品面积(㎡)'),
  },
  {
    prop: 'textureGrainInfo',
    headSlotName: 'headTextureGrainInfo',
    label: getLangeKey('对纹组'),
    widthType: 'width',
    width: '120px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '对纹组一',
    customLabel: getLangeKey('对纹组'),
  },
]
// lbl 账号的表格头部配置
const lblHeaderList: HeaderT = [
  {
    prop: 'remarks',
    headSlotName: 'headRemarks',
    label: getLangeKey('备注信息'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息',
    customLabel: getLangeKey('备注信息'),
  },
  {
    prop: 'remark1',
    headSlotName: 'headRemark1',
    label: getLangeKey('备注信息1'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息1',
    customLabel: getLangeKey('备注信息1'),
  },
  {
    prop: 'remark2',
    headSlotName: 'headRemark2',
    label: getLangeKey('备注信息2'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息2',
    customLabel: getLangeKey('备注信息2'),
  },
  {
    prop: 'remark3',
    headSlotName: 'headRemark3',
    label: getLangeKey('备注信息3'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息3',
    customLabel: getLangeKey('备注信息3'),
  },
  {
    prop: 'remark4',
    headSlotName: 'headRemark4',
    label: getLangeKey('备注信息4'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息4',
    customLabel: getLangeKey('备注信息4'),
  },
  {
    prop: 'remark5',
    headSlotName: 'headRemark5',
    label: getLangeKey('备注信息5'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息5',
    customLabel: getLangeKey('备注信息5'),
  },
  {
    prop: 'remark6',
    headSlotName: 'headRemark6',
    label: getLangeKey('备注信息6'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息6',
    customLabel: getLangeKey('备注信息6'),
  },
  {
    prop: 'remark7',
    headSlotName: 'headRemark7',
    label: getLangeKey('备注信息7'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息7',
    customLabel: getLangeKey('备注信息7'),
  },
  {
    prop: 'remark8',
    headSlotName: 'headRemark8',
    label: getLangeKey('备注信息8'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息8',
    customLabel: getLangeKey('备注信息8'),
  },
  {
    prop: 'remark9',
    headSlotName: 'headRemark9',
    label: getLangeKey('备注信息9'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息9',
    customLabel: getLangeKey('备注信息9'),
  },
  {
    prop: 'remark10',
    headSlotName: 'headRemark10',
    label: getLangeKey('备注信息10'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息10',
    customLabel: getLangeKey('备注信息10'),
  },
  {
    prop: 'remark11',
    headSlotName: 'headRemark11',
    label: getLangeKey('备注信息11'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息11',
    customLabel: getLangeKey('备注信息11'),
  },
  {
    prop: 'remark12',
    headSlotName: 'headRemark12',
    label: getLangeKey('备注信息12'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息12',
    customLabel: getLangeKey('备注信息12'),
  },
  {
    prop: 'remark13',
    headSlotName: 'headRemark13',
    label: getLangeKey('备注信息13'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息13',
    customLabel: getLangeKey('备注信息13'),
  },
  {
    prop: 'remark14',
    headSlotName: 'headRemark14',
    label: getLangeKey('备注信息14'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息14',
    customLabel: getLangeKey('备注信息14'),
  },
  {
    prop: 'remark15',
    headSlotName: 'headRemark15',
    label: getLangeKey('备注信息15'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息15',
    customLabel: getLangeKey('备注信息15'),
  },
  {
    prop: 'remark16',
    headSlotName: 'headRemark16',
    label: getLangeKey('备注信息16'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '备注信息16',
    customLabel: getLangeKey('备注信息16'),
  },
]
export { headerList, lblHeaderList }
